<template>
  <header>
    <div class="header-top">
      <slot name="title" />
      <div class="header-ui">
        <slot name="ui" />
      </div>
    </div>

    <slot />
  </header>
</template>
<style lang="scss" scoped>
header {
  display: flex;
  position: relative;
  z-index: 2;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--gap_n);
  overflow: hidden;
  background: var(--color_neutral_50);
  box-shadow: rgb(0 0 0 / 10%) 0 10px 15px -3px, rgb(0 0 0 / 5%) 0 4px 6px -2px;
  gap: var(--gap_n);
  @include above('l') {
    position: relative;
  }
}
.header-top {
  display: grid;
  z-index: 2;
  grid-template-columns: 1fr auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  pointer-events: none;
  gap: 1rem;
}
.header-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.header-ui {
  align-self: flex-start;
  pointer-events: auto;
}
</style>
